import shave from 'shave';

import isMobile from '../../../resources/scripts/helpers/is-mobile';

class BrixPostArchive {
  static init(...parameters) {
    return new BrixPostArchive(...parameters);
  }

  constructor(block) {
    this.preamble = block.querySelectorAll('.preamble');
    this.header = block.querySelectorAll('.h4');
    if (this.preamble && this.header) {
      this.truncateEventTitle();
    }
  }

  truncateEventTitle() {
    if (isMobile()) {
      Array.from(this.header).forEach((title) => {
        shave(title, 60);
      });
    } else {
      Array.from(this.header).forEach((title) => {
        shave(title, 30);
      });
      Array.from(this.preamble).forEach((title) => {
        shave(title, 110);
      });
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-post-archive', BrixPostArchive.init);
}
